"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSanityImageUrlBuilder = void 0;
const image_url_1 = __importDefault(require("@sanity/image-url"));
const MapmakerAppConfig_1 = require("../../../../client/MapmakerAppConfig");
function useSanityImageUrlBuilder() {
    const { sanity } = (0, MapmakerAppConfig_1.useMapmakerAppConfig)();
    return (0, image_url_1.default)({
        dataset: sanity.dataset,
        projectId: sanity.projectId,
    });
}
exports.useSanityImageUrlBuilder = useSanityImageUrlBuilder;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9oZWxwL3Nhbml0eS9zZXJpYWxpemVycy91dGlscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxrRUFBc0Q7QUFDdEQsNEVBQTRFO0FBRTVFLFNBQWdCLHdCQUF3QjtJQUN0QyxNQUFNLEVBQUUsTUFBTSxFQUFFLEdBQUcsSUFBQSx3Q0FBb0IsR0FBRSxDQUFDO0lBQzFDLE9BQU8sSUFBQSxtQkFBcUIsRUFBQztRQUMzQixPQUFPLEVBQUUsTUFBTSxDQUFDLE9BQU87UUFDdkIsU0FBUyxFQUFFLE1BQU0sQ0FBQyxTQUFTO0tBQzVCLENBQUMsQ0FBQztBQUNMLENBQUM7QUFORCw0REFNQyJ9